export const testAudioBufferCopyChannelMethodsSubarraySupport = (nativeAudioBuffer) => {
    const source = new Float32Array(2);
    try {
        /*
         * Firefox up to version 67 didn't fully support the copyFromChannel() and copyToChannel() methods. Therefore testing one of those
         * methods is enough to know if the other one it supported as well.
         */
        nativeAudioBuffer.copyFromChannel(source, 0, nativeAudioBuffer.length - 1);
    }
    catch (_a) {
        return false;
    }
    return true;
};
//# sourceMappingURL=/build/es2018/helpers/test-audio-buffer-copy-channel-methods-subarray-support.js.map